export const INPUTS = [
  {
    param: "firstname_vch",
    label: "First Name",
    placeholder: "First",
    classNames: "col-12 col-md-6",
    disabled: true,
    // isRequired: true,
  },
  {
    param: "lastname_vch",
    label: "Last Name",
    placeholder: "Last",
    classNames: "col-12 col-md-6",
    disabled: true,
    // isRequired: true,
  },
  {
    param: "sms_number_vch",
    label: "SMS Number",
    placeholder: "+1 (111) 222-3333",
    type: "phone",
    classNames: "col-12",
  },
  // {
  //   param: "phone_number_vch",
  //   label: "Phone Number",
  //   placeholder: "+1 (111) 222-3333",
  //   type: "phone",
  //   classNames: "col-12 ",
  // },
  {
    param: "email_vch",
    label: "Email Address",
    placeholder: "sample@email.com",
    type: "email",
    classNames: "col-12",
  },
];
